import React, { useState } from "react";
import styled from "styled-components";

//
import Tab from "./sections/tab/Tab";
import Editor from "./sections/tab-items/Editor";
import View from "./sections/tab-items/View";
import Test from "./sections/tab-items/Test";
import Solution from "./sections/tab-items/Solution";
import Action from "./sections/action/Action";

export default function Right() {
  const [tab, setTab] = useState("editor");

  function changeTab(v) {
    setTab(v);
  }

  return (
    <StyledRight className="lesson_board col-12 col-md-6 col-lg-7 x-h-md-100">
      <div className="lesson x-h-md-100">
        <Tab tab={tab} changeTab={changeTab} />

        <div className="lesson_content h-100 overflow-auto">
          <Editor tab={tab} />
          <View tab={tab} />
          <Test tab={tab} />
          <Solution tab={tab} />
        </div>
        <Action />
      </div>
    </StyledRight>
  );
}

const StyledRight = styled.div``;
